/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, useState } from "react";

import { Button, Icon, SheetContainer, Text } from "@bookingcom/bui-react";
import { I18nChildContext, t, useI18n } from "@bookingcom/lingojs-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import flights_merch_toolkit_offer_pinning_v2 from "../../../../../utils/experiments/genius/flights_merch_toolkit_offer_pinning_v2";
import type { HighlightInfoTooltip } from "./types";

type Props = {
  infoTooltip: HighlightInfoTooltip;
};

const FlightCardGeniusHighlightBottomSheetWrapper: FC<Props> = ({ infoTooltip }) => {
  const i18n = useI18n() as I18nChildContext;
  const [isBottomSheetActive, setBottomSheetActive] = useState(false);

  return (
    <>
      <Button
        variant="tertiary"
        attributes={{
          "aria-label": infoTooltip.ariaLabel,
          onClick: (event: React.MouseEvent) => {
            event.stopPropagation();
            event.preventDefault();
            setBottomSheetActive(true);
          }
        }}
      >
        <Icon size="medium" svg={InfoSignIcon} />
      </Button>

      <SheetContainer
        active={isBottomSheetActive}
        onCloseTrigger={() => setBottomSheetActive(false)}
        closeAriaLabel={i18n.trans(t("a11y_flights_sr_genius_pinned_deal_close_popup"))}
        position="bottom"
        title={infoTooltip.title ?? ""}
        onOpen={async () => {
          flights_merch_toolkit_offer_pinning_v2.goals.featured_info_displayed();
        }}
      >
        <Text>{infoTooltip.content}</Text>
      </SheetContainer>
    </>
  );
};

export default FlightCardGeniusHighlightBottomSheetWrapper;
